<template>
  <v-card class="allergens-container">
    <v-card-title>{{ $t('allergens') }}</v-card-title>
    <v-card-text>
      <v-row justify="center" align="center">
        <v-col
          class="py-1 col-md-5 col-8 allergen"
          v-for="allergen of allergens"
          :key="allergen.id"
        >
          <v-checkbox
            dense
            hide-details
            class="mt-0"
            v-model="allergen.selected"
          >
            <div slot="label" class="children-inline">
              <img
                class="allergen-img"
                :src="`${uploadsPath}/static/alergenos/${allergen.picture}.png`"
              />
              <span>{{ allergen.name }}</span>
            </div>
          </v-checkbox>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions class="justify-end">
      <v-btn text @click="cancel">{{ $t('cancel') }}</v-btn>
      <v-btn color="primary" @click="save">{{ $t('save') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script lang="ts">
  import { Component, Vue, Prop } from 'vue-property-decorator';
  import { Allergens, allergensNames } from '../../enums/Allergens';
  import { IItem } from '../../interfaces/IItem';
  import { Globals } from '@/modules/Globals';

  @Component
  export default class AllergensModal extends Vue {
    @Prop() item: IItem;
    allergens = [];

    get uploadsPath() {
      return Globals.uploadsPath;
    }

    mounted() {
      let allergens = this.item.allergens;

      for (let a in Allergens) {
        const val = parseInt(a, 10);
        var isNumber = val >= 0;
        if (isNumber) {
          const allergen = {
            name: this.$tc(allergensNames[a]),
            picture: Allergens[a].toLowerCase(),
            id: val,
            selected: (allergens & val) == val,
          };
          this.allergens.push(allergen);
        }
      }
    }

    save() {
      let allergens = 0;

      for (let allergen of this.allergens) {
        if (allergen.selected) allergens |= allergen.id;
      }

      this.$parent.$emit('saved', allergens);
      this.$emit('close');
    }

    cancel() {
      this.$emit('close');
    }
  }
</script>
